import React from 'react'
import Survey from '../pages/Survey'

const Project = () => {
  return (
    <div>
      <Survey />
    </div>
  )
}

export default Project